import { getApiGalaxyServer } from 'services';
import {
  SearchTeamsByFieldsPayload,
  SearchTeamsByFieldsResponse,
} from 'TeamModule/api/searchTeamsByFieldsApi';

export interface GetTeamsForExportPayload {
  filters?: SearchTeamsByFieldsPayload;
}

export interface GetTeamsForExportErrorResponse {
  message: string;
  error: string;
  statusCode: number;
}

export type GetTeamsForExportResponse = SearchTeamsByFieldsResponse;

export const getTeamsForExportApi = ({
  params,
  token,
  config,
}: BaseApiParams<SearchTeamsByFieldsPayload>) =>
  getApiGalaxyServer(`/lookup/teams/searchByFields`, { ...config, params: params as any }, token);

export default getTeamsForExportApi;
